module Omni.Booker {
    export let NgModule = angular.module("omni.booker", []);   
}